function onFeedbackClick(event) {
  event.preventDefault();
  const input = event.currentTarget.input;
  input.value = '';

  const fb = input.previousElementSibling;
  fb.classList.add('opacity-0');
}

function onInputChange(event) {
  event.preventDefault();
  const input = event.currentTarget.input;
  const fb = event.currentTarget.fb;

  if (input.value) fb.classList.remove('opacity-0');
  else fb.classList.add('opacity-0');
}

export default function initSearchClear() {
  const input = document.querySelectorAll('.search-clear');

  input.forEach((el) => {
    const fb = el.previousElementSibling;
    
    el.input = el;
    el.fb = fb;
    el.removeEventListener('input', onInputChange);
    el.addEventListener('input', onInputChange);
    
    fb.input = el;
    fb.removeEventListener('click', onFeedbackClick);
    fb.addEventListener('click', onFeedbackClick);
  });
}
